import { Box } from "@mui/material";
import CrownGold from "assets/crownGold.svg";
import CrownGray from "assets/crownGray.svg";
import CrownOutlined from "assets/crownOutlined.svg";
import CrownPurple from "assets/crownPurple.svg";
import type { CustomerUserCategoryTier } from "shared";

// One artwork per tier, supplied by design — all four are 20x20 vector paths
// that share the same crown geometry, so they line up in the ladder.
//
// VIP deliberately does NOT use the app-wide `assets/crown.svg`: that one is a
// 16x16 raster base64-embedded in a <pattern>, so scaled to 20px it rendered
// visibly heavier and differently proportioned than its three siblings.
// `crown.svg` stays untouched for its 15 other consumers (tickets tables,
// dispatch portal, merge/child drawers); only this ladder moved to the vector.
const TIER_ICON: Record<CustomerUserCategoryTier, string> = {
  customer_owner: CrownPurple,
  vip: CrownGold,
  manager: CrownGray,
  standard: CrownOutlined,
};

const TIER_LABEL: Record<CustomerUserCategoryTier, string> = {
  customer_owner: "customer owner",
  vip: "VIP",
  manager: "manager",
  standard: "standard",
};

export const CrownTierIcon = ({
  tier,
  size = 20,
}: {
  tier: CustomerUserCategoryTier | null;
  size?: number;
}) => {
  if (!tier) return null;

  return (
    <Box
      component="img"
      src={TIER_ICON[tier]}
      alt={`${TIER_LABEL[tier]} crown`}
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        objectFit: "contain",
        display: "block",
      }}
    />
  );
};
